import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  WRichTextDefinition,
  WRichTextProps,
} from '@wix/thunderbolt-components';
// TODO - import this directly from '@wix/thunderbolt-components' once this PR is merged - https://github.com/wix-private/thunderbolt/pull/16428/files
import { WRichTextSelectorCSSVars as WRichTextSelectorCSSCarmiData } from '@wix/thunderbolt-components/dist/components/WRichText/WRichText';
import {
  props as viewerPropsMapper,
  css as viewerCssMapper,
} from './WRichText.mapper';

const props = composeMapper<
  PreviewWrapperProps<WRichTextProps>,
  WRichTextDefinition,
  WRichTextProps
>()(
  viewerPropsMapper,
  { add: ['compPreviewState', 'componentViewMode', 'compProps', 'compLayout'] },
  (resolver, dependencies, carmiData) => {
    const { minHeight, minWidth, verticalText } = dependencies.compProps || {};
    const { height, width } = dependencies.compLayout;
    const viewerProps = resolver(dependencies, carmiData);
    const { compPreviewState, componentViewMode } = dependencies;
    // Using `carmiData` inside the previewMapper is discouraged in general and will be removed once
    // this refactor ticket is complete - https://jira.wixpress.com/browse/ECL-1863
    const { html } = carmiData;
    return {
      ...viewerProps,
      html,
      previewWrapperProps: {
        compPreviewState,
        componentViewMode,
        verticalText,
        minHeight,
        minWidth,
        height,
        width,
      },
    };
  },
);

type WRichTextSelectorCSSVars = WRichTextSelectorCSSCarmiData & {
  'pointer-events'?: string;
};
const css = composeMapper<
  WRichTextSelectorCSSVars,
  WRichTextDefinition,
  WRichTextSelectorCSSCarmiData
>()(
  viewerCssMapper,
  { add: ['componentViewMode'] },
  (resolver, dependencies, carmiData) => {
    const viewerCss = resolver(dependencies, carmiData);
    const previewCss: Partial<WRichTextSelectorCSSVars> = {};
    if (dependencies.componentViewMode === 'editor') {
      previewCss['pointer-events'] = 'auto';
    }
    return { ...viewerCss, ...previewCss };
  },
);

export default createComponentPreviewMapperModel({
  props,
  css,
});
